import React from 'react';
import styled from 'styled-components';
import Button from '../Button';

const StyledButton = styled(Button)({
  // TODO: Try to remove once we get rid of all scss styles
  '&&': {
    // Temporary bump for specificity
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:active': {
      opacity: 0.8,
    },
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
  },
});

export const LinkButton = (props) => {
  const btnProps = {
    ...props,
    textColorName: 'link',
    noPseudo: true,
  };

  return <StyledButton {...btnProps} />;
};

export default LinkButton;
